import { render } from "./TipTapEditorComponent.vue?vue&type=template&id=ed5aea48"
import script from "./TipTapEditorComponent.vue?vue&type=script&lang=js"
export * from "./TipTapEditorComponent.vue?vue&type=script&lang=js"

import "./TipTapEditorComponent.vue?vue&type=style&index=0&id=ed5aea48&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__